<template>
    <div class="p-3 bg-light h-100">
        <div class="sa-list-component">
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" :align="'right'"
                            size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="b-table-sticky-header">
                <template v-if="items.length > 0">
                    <div class="p-3 bg-light">
                        <div class="card sa-siat-card-pratica shadow-sm mb-3" v-for="(pratica, index) of items"
                            :key="index">
                            <div class="sa-siat-card-header-custom p-3 border-bottom">
                                <b-row>
                                    <b-col cols="12">
                                        <div class="d-flex justify-content-between align-items-center w-100">
                                            <span class="text-muted small font-weight-bold">N° {{ index + 1 }}</span>
                                            <span :class="getClassBadge(pratica)">{{ pratica.stato.toUpperCase()
                                            }}</span>
                                            <b-badge pill variant="light"
                                                class="text-primary border border-primary px-2 py-1 font-weight-bold"
                                                style="font-family: monospace; font-size: 1rem; letter-spacing: 0.5px;">
                                                🩺 PRATICA: <b>{{ pratica.pr_id }}</b>
                                            </b-badge>
                                        </div>

                                        <h5 class="m-0 mt-2 text-muted sa-ft-label text-uppercase"
                                            style="font-size: 0.85rem;">
                                            Assistito
                                        </h5>
                                        <h3 class="m-0 font-weight-bold text-dark mt-1" style="font-size: 1.5rem;">
                                            {{ pratica.assistito.codiceFiscale }}
                                        </h3>
                                    </b-col>
                                </b-row>
                            </div>

                            <div class="p-3 bg-white">


                                <div class="bg-light">
                                    <b-row>
                                        <b-col cols="2">
                                            <div class="sa-ft-data">
                                                <label class="sa-ft-label">Livello Assistenziale</label>
                                                <span class="sa-ft-badge">{{ pratica.livelloAssistenziale }}
                                                </span>
                                            </div>
                                        </b-col>
                                        <b-col cols="2">
                                            <div class="sa-ft-data">
                                                <label class="sa-ft-label">Bisogno</label>
                                                <span :class="getClassBadgeBisogno(pratica)">{{
                                                    pratica.bisogno.toUpperCase() }}</span>
                                            </div>
                                        </b-col>
                                        <b-col cols="2">
                                            <div class="sa-ft-data">
                                                <label class="sa-ft-label">Nominativo</label>
                                                <label class="sa-ft-value">{{ pratica.assistito.cognome }} {{
                                                    pratica.assistito.nome }}</label>
                                            </div>
                                        </b-col>
                                        <b-col cols="2">
                                            <div class="sa-ft-data">
                                                <label class="sa-ft-label">Domicilio</label>
                                                <label class="sa-ft-value">{{ pratica.assistito.indirizzoDiDomicilio }}
                                                    {{ pratica.assistito.nCivicoDiDomicilio }}</label>
                                            </div>
                                        </b-col>

                                        <b-col cols="2">
                                            <div class="sa-ft-data">
                                                <label class="sa-ft-label">Distretto</label>
                                                <label class="sa-ft-value">{{ pratica.distretto.descrizione }}
                                                </label>
                                            </div>
                                        </b-col>
                                        <b-col cols="2">
                                            <div class="sa-ft-data">
                                                <label class="sa-ft-label">Telefono</label>
                                                <label class="sa-ft-value">{{ pratica.assistito.telefono }}</label>
                                            </div>
                                        </b-col>

                                    </b-row>
                                </div>

                            </div>

                            <div class="card-body p-3 border-top bg-white">
                                <h5 class="m-0 ml-3 mt-2 text-muted sa-ft-label text-uppercase"
                                    style="font-size: 0.85rem;">
                                    Pacchetti Assistenziali
                                </h5>
                                <div v-for="pacchetto, indice of pratica.pacchettoAssistenziale" :key="indice"
                                    class="p-2">

                                    <div class="sa-utility-section d-flex justify-content-between align-items-center pb-2 p-3"
                                        v-b-toggle="'collapse-prestazione-' + pratica.assistito.codiceFiscale + pacchetto.pacchettoCodice + '-' + indice"
                                        style="cursor: pointer; user-select: none;">
                                        <div>
                                            <b style="color: var(--bg-sidebar); font-size: 20px">📄</b>
                                            <span class="sa-articolo-section-title ml-2 font-weight-bold"> {{
                                                pacchetto.pacchettoCodice }} - {{
                                                    pacchetto.pacchettoDescrizione }} - {{ pacchetto.statoRecord }}</span>
                                        </div>
                                        <i class="fas fa-chevron-up sa-ft-icona-collapse"></i>
                                    </div>
                                    <b-collapse
                                        :id="'collapse-prestazione-' + pratica.assistito.codiceFiscale + pacchetto.pacchettoCodice + '-' + indice"
                                        class="mt-2">
                                        <div class="p-2 bg-light rounded border">
                                            <h5 class="m-0 ml-3 mt-2 text-muted sa-ft-label text-uppercase"
                                                style="font-size: 0.85rem;">
                                                Eventi
                                            </h5>
                                            <div v-for="evento, indice of pacchetto.evento" :key="indice" class="p-2">
                                                <b-row class="p-2">
                                                    <b-col cols="2">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-label">Id</label>
                                                            <label class="sa-ft-value">{{ evento.id }}
                                                            </label>
                                                        </div>
                                                    </b-col>
                                                    <b-col cols="2">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-label">Tipologia</label>
                                                            <label class="sa-ft-value">{{ evento.tipo.toUpperCase() }}
                                                            </label>
                                                        </div>
                                                    </b-col>
                                                    <b-col cols="2">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-label">Stato</label>
                                                            <label class="sa-ft-value">{{
                                                                evento.statoRecord.toUpperCase() }}
                                                            </label>
                                                        </div>
                                                    </b-col>
                                                    <b-col cols="6"
                                                        class="d-flex flex-column align-items-end text-right">

                                                    </b-col>
                                                    <b-col cols="12">
                                                        <h5 class="m-0  mt-2 text-muted sa-ft-label text-uppercase"
                                                            style="font-size: 0.85rem;">
                                                            Prestazioni
                                                        </h5>
                                                        <ul class="list-unstyled mb-0">
                                                            <li v-for="(prestazione, i) of evento.prestazione" :key="i"
                                                                class="d-flex justify-content-between align-items-center py-2 border-bottom text-decoration-line-through">

                                                                <div
                                                                    class="d-flex align-items-center text-truncate mr-2">

                                                                    <span class="mr-2 rounded-circle bg-primary"
                                                                        style="margin-left: 8px; width: 6px; height: 6px; display: inline-block; flex-shrink: 0;">
                                                                    </span>

                                                                    <label
                                                                        class="sa-ft-value font-monospace m-0 text-truncate font-weight-bold">
                                                                        {{ prestazione.tipoPrestazione }}
                                                                    </label>

                                                                    <button type="button"
                                                                        @click.stop="onClickApriDettaglioPrestazione(prestazione)"
                                                                        class="btn btn-link text-info p-0 mx-2 d-inline-flex align-items-center"
                                                                        v-b-tooltip.hover
                                                                        title="Visualizza dettagli prestazione"
                                                                        style="font-size: 1.1rem; line-height: 1; text-decoration: none;">
                                                                        <i class="fas fa-info-circle"></i>
                                                                    </button>

                                                                    <span
                                                                        class="text-muted font-italic small text-truncate">
                                                                        ({{ prestazione.figuraProfessionale.value }})
                                                                    </span>
                                                                </div>

                                                                <div class="d-flex align-items-center ml-auto"
                                                                    v-if="evento.statoRecord === 'NUOVO'">
                                                                    <button
                                                                        @click.stop="onClickAccettaRifiutaPai(prestazione, evento, pacchetto.pacchettoCodice, 'Accettato')"
                                                                        class="mr-1 no-text rounded-circle sa-ft-floating-btn success">
                                                                        <i>✅</i>
                                                                    </button>
                                                                    <button
                                                                        @click.stop="onClickAccettaRifiutaPai(prestazione, evento, pacchetto.pacchettoCodice, 'Respinto')"
                                                                        class="no-text rounded-circle sa-ft-floating-btn danger">
                                                                        <i>❌</i>
                                                                    </button>
                                                                </div>

                                                            </li>
                                                        </ul>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </div>
                                    </b-collapse>

                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <NoDataComponent v-else ref="cmpNoDataComponent" title="Non sono presenti Richieste Pratiche"
                    nome="no-data" subtitle="" icon="fas fa-clipboard" />
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-modal ref="mdlDettaglioPrestazione" id="mdlDettaglioPrestazione" size="xl"
                @hide="onHideModalDettaglioPrestazione" @shown="onShownModal" style="height: 100%; width: 100%"
                title="Informazioni Prestazione">
                <b-row>
                    <b-col cols="12">
                        <div class="sa-ft-data">
                            <label class="sa-ft-label">Prestazione</label>
                            <label class="sa-ft-value">{{ prestazioneSelezionata.tipoPrestazione }}</label>
                        </div>
                    </b-col>
                    <b-col cols="2">
                        <div class="sa-ft-data">
                            <label class="sa-ft-label">Figura Professionale</label>
                            <label class="sa-ft-value">{{ prestazioneSelezionata.figuraProfessionale.value }}</label>
                        </div>
                    </b-col>
                    <b-col cols="2">
                        <div class="sa-ft-data">
                            <label class="sa-ft-label">Data inizio interventi</label>
                            <label class="sa-ft-value">{{ prestazioneSelezionata.dataInizioInterventi }}</label>
                        </div>
                    </b-col>
                    <b-col cols="2">
                        <div class="sa-ft-data">
                            <label class="sa-ft-label">Data fine interventi</label>
                            <label class="sa-ft-value">{{ prestazioneSelezionata.dataFinePiano == null ? '--' :
                                prestazioneSelezionata.dataFinePiano }}</label>
                        </div>
                    </b-col>
                    <b-col cols="2">
                        <div class="sa-ft-data">
                            <label class="sa-ft-label">Intervento</label>
                            <label class="sa-ft-value">{{ prestazioneSelezionata.frequenza.numeroInterventi }} {{
                                prestazioneSelezionata.frequenza.utNumeroInterventi }} </label>
                        </div>
                    </b-col>
                    <b-col cols="2">
                        <div class="sa-ft-data">
                            <label class="sa-ft-label">Ripetizione</label>
                            <label class="sa-ft-value">{{ prestazioneSelezionata.frequenza.numeroRipetizioni }} {{
                                prestazioneSelezionata.frequenza.utNumeroRipetizioni }} </label>
                        </div>
                    </b-col>
                    <b-col cols="2">
                        <div class="sa-ft-data">
                            <label class="sa-ft-label">Interventi Totali</label>
                            <label class="sa-ft-value">{{ prestazioneSelezionata.intervento.length }} </label>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="b-table-sticky-header" style="height: 250px; overflow-y: scroll;">
                            <b-table sticky-header ref="table" stacked="lg" striped hover
                                :items="prestazioneSelezionata.intervento" :fields="fieldsIntervento" :current-page="1"
                                :per-page="1000" sort-icon-left head-variant="light" class="sa-b-table">
                                <template #cell(index)="row">
                                    <span> {{ row.index + 1 }} </span>
                                </template>
                                <template #cell(dataPrevista)="row">
                                    <span> {{ row.item.dataPrevista.split(" ")[0] ? row.item.dataPrevista.split(" ")[0]
                                        : row.item.dataPrevista }} {{ row.item.oraPrevista }} </span>
                                </template>

                                <!-- <template v-slot:cell(actions)="row">
                                    <b-container class="bv-example-row">
                                        <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success"
                                            @click="onClickEditSoggetti(row.item)">
                                            <font-awesome-icon icon="edit"> </font-awesome-icon>
                                        </b-button>
                                        <b-button size="sm" v-b-tooltip.hover title="Cancella" variant="outline-danger"
                                            @click="onClickDeleteSoggetti(row.item)" class="mr-1 no-text">
                                            <font-awesome-icon icon="trash"></font-awesome-icon>
                                        </b-button>
                                    </b-container>
                                </template> -->
                            </b-table>

                        </div>
                    </b-col>
                </b-row>

            </b-modal>
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" :align="'right'"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import NoDataComponent from '../../../template/components/utility/NoDataComponent.vue';
import UtilityMixin from '../../utility/UtilityMixin.js';
import SiatMixin from '../mixins/SiatMixin.js';

export default {
    components: { NoDataComponent },
    mixins: [UtilityMixin, SiatMixin],
    data() {
        return {
            currentPage: 1,
            perPage: 50,
            rows: 0,
            items: [],
            prestazioneSelezionata: {
                figuraProfessionale: {},
                frequenza: {},
                intervento: []
            },
            fieldsIntervento: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 2rem",
                },
                {
                    label: "Identificativo",
                    key: "id",

                },
                {
                    label: "Data Prevista",
                    key: "dataPrevista",

                },
                {
                    label: "Stato",
                    key: "statoRecord",

                },

            ],
            pathResource: "/siatpratichescelte",
            fields: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 2rem",
                },
                { key: 'data_ora_proposta', label: 'Data Ora Proposta' },
                { key: 'tipo_proposta', label: 'Tipologia' },
                { key: 'pr_id', label: 'Pratica' },
                { key: 'nominativo', label: 'Nominativo', thStyle: "width: 12rem" },
                { key: 'bisogno', label: 'Bisogno' },
                { key: 'stato', label: 'Stato Pratica' },
                {
                    key: 'pacchettoAssistenziale', label: 'N.Pacc.Assistenziale', formatter: (value) => {
                        return value.length;
                    }
                },
                // { key: 'notificato_da', label: 'Notificato da' },
                { key: 'actions', label: '', thStyle: "width: 8rem", }
            ]
        }
    },

    mounted() {
        this.loadData();
    },

    methods: {
        loadData() {
            let filter = {
                page: this.currentPage,
                perPage: this.perPage
            }
            this.loadDataResources(this.pathResource + "/", filter, this.loadDataSuccess, this.loadDataError);
        },
        loadDataSuccess(response) {
            this.items = response.data.data.list;
            this.rows = response.data.data.recordsNumber;

        },
        loadDataError(error) {
            error;
        },
        onClickApriDettaglioPrestazione(prestazione) {
            this.prestazioneSelezionata = prestazione;
            this.openModalDettaglio();

        },
        onHideModalDettaglioPrestazione() {
            this.prestazioneSelezionata = {
                figuraProfessionale: {},
                frequenza: {},
                intervento: []
            }
        },
        onShownModal() { },
        openModalDettaglio() {
            this.$refs.mdlDettaglioPrestazione.show();
        },
        closeModalDettaglio() {
            this.$refs.mdlDettaglioPrestazione.hide();
        },




        normalizedData() {
            // console.log("ngulo a me");
            // let map = {};
            // for (let item of this.items) {
            //     const cf = item.assistito.codiceFiscale;
            //     console.log(item, cf);
            //     if (!map[cf]) {
            //         map[cf] = { assistito: item.assistito };
            //     }
            //     for (let pacchetto of item.pacchettoAssistenziale) {
            //         const pCodice = pacchetto.pacchettoCodice;
            //         if (!map[cf][pCodice]) {
            //             map[cf][pCodice] = { pacchetto: pacchetto };
            //         }
            //         for (let evento of pacchetto.evento) {
            //             const eId = evento.id;
            //             if (!map[cf][pCodice][eId]) {
            //                 map[cf][pCodice][eId] = [];
            //             }
            //             map[cf][pCodice][eId].push(evento);
            //         }
            //     }
            // }
            // console.log("MAPP FINALE ", map);


            return this.items;


        },
        getClassBadgeBisogno(item) {
            switch (item.bisogno) {
                case "Complesso":
                    return "sa-ft-badge orange"
                default:
                    return "sa-ft-badge";
            }

        },
        getClassBadge(item) {
            switch (item.stato.toUpperCase()) {
                case "APERTA":
                    return "sa-ft-badge success"
                case "CHIUSA":
                    return "sa-ft-badge danger"
                default:
                    return "sa-ft-badge";
            }

        },
    }
}
</script>

<style lang="scss" scoped>
.bg-light-section {
    background-color: #fcfdfe;
}

.custom-siat-tabs .nav-link {
    border-radius: 4px 4px 0 0;
    margin-right: 2px;
    opacity: 0.85;
}

.custom-siat-tabs .nav-link.active {
    opacity: 1;
    border-bottom: 2px solid transparent !important;
}

.tracking-wider {
    letter-spacing: 0.05em;
}

.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    margin-bottom: 25px;
    overflow: hidden;
}

.sa-siat-card-header-custom {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    padding: 15px 20px;

}

.sa-siat-text-indirizzo {
    font-size: 1rem;
}

.sa-utility-section.collapsed .sa-ft-icona-collapse {
    transform: rotate(180deg);

}

/* Effetto hover */
.sa-utility-section:hover .sa-ft-icona-collapse {
    color: var(--bg-sidebar);
}
</style>